import FooterButtons from "@/components/common/FooterButtons";
import { useActionCopy } from "@/features/i18n/actionCopy";

export interface OnboardingTertiaryAction {
    label?: string;
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
}

interface OnboardingStepFooterProps {
    onBack?: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    /** When true, primary action submits the parent form. */
    submit?: boolean;
    primaryLabel?: string;
    /** Full-width secondary control under Back and Next, usually Skip. */
    tertiary?: OnboardingTertiaryAction;
}

/** Demo-style paired Back + Next footer for profile onboarding steps. */
export function OnboardingStepFooter({
    onBack,
    disabled,
    isLoading,
    submit = true,
    primaryLabel,
    tertiary,
}: OnboardingStepFooterProps) {
    const copy = useActionCopy();

    return (
        <FooterButtons
            type1={submit ? "submit" : "button"}
            words1={primaryLabel ?? copy.next}
            words2={onBack ? copy.back : undefined}
            words3={tertiary ? (tertiary.label ?? copy.skip) : undefined}
            func2={onBack}
            func3={tertiary?.onClick}
            disabled1={disabled}
            disabled3={tertiary?.disabled}
            isLoading1={isLoading}
            isLoading3={tertiary?.isLoading}
            primaryAction="next"
            secondaryAction="back"
            tertiaryAction={tertiary ? "skip" : undefined}
            testId1={onBack ? undefined : "next-button"}
        />
    );
}
